<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 20:14:16
 * @LastEditTime: 2019-08-16 14:38:07
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="门店订货排行(门店)" name="first">
                   <div class="countType">
                <el-button size="mini" @click="countFun('0')" :class="{'active':is_active=='0'}">累计排行</el-button>

                <el-button size="mini" @click="countFun('1')" :class="{'active':is_active=='1'}">本周排行</el-button>
                <el-button size="mini" @click="countFun('2')" :class="{'active':is_active=='2'}">本月排行</el-button>
                <el-button size="mini" @click="countFun('3')" :class="{'active':is_active=='3'}">本年排行</el-button>

                  </div>
                <el-table
                        ref="multipleTable"
                        :data="tableData1"
                        v-loading="loading"
                        border
                        stripe
                        style="width: 100%;margin: 20px">
                    <el-table-column
                            prop=""
                            label="top100排名"
                            fixed>
                           <template slot-scope="scope">
                               {{Number(pageSize1*(pageNo1-1)+scope.$index+1)}}
                           </template>
                    </el-table-column>
                    <el-table-column
                            prop="to_sn"
                            label="门店编号"
                            show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column
                            prop="to_name"
                            label="门店名称"
                            show-overflow-tooltip>
                        <template slot-scope="scope">

                        </template>
                    </el-table-column>
                    <el-table-column
                            prop=""
                            label="产品规格"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="real_stock_out_num"
                            label="订货数量"
                            show-overflow-tooltip>
                    </el-table-column>
                 
                
                   
                </el-table>
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="pageNo1"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize1">
                </el-pagination>

            </el-tab-pane>
            <el-tab-pane label="门店订货排行（产品）" name="second">
               <div class="countType">
                <el-button size="mini" @click="countFun('0')" :class="{'active':is_active=='0'}">累计排行</el-button>

                <el-button size="mini" @click="countFun('1')" :class="{'active':is_active=='1'}">本周排行</el-button>
                <el-button size="mini" @click="countFun('2')" :class="{'active':is_active=='2'}">本月排行</el-button>
                <el-button size="mini" @click="countFun('3')" :class="{'active':is_active=='3'}">本年排行</el-button>


                  </div>
                <el-table
                        ref="multipleTable"
                        :data="tableData2"
                        v-loading="loading"
                        border
                        stripe
                        style="width: 100%;margin: 20px">
                     <el-table-column
                            prop=""
                            label="top100排名"
                            fixed>
                                <template slot-scope="scope">
                               {{Number(pageSize1*(pageNo1-1)+scope.$index+1)}}
                           </template>
                    </el-table-column>
                    <el-table-column
                            prop="product_sn"
                            label="产品编号"
                            show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column
                            prop="product_name"
                            label="产品名称"
                            show-overflow-tooltip>
                        <template slot-scope="scope">

                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="product_specs"
                            label="产品规格"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="stock_total"
                            label="订货数量"
                            show-overflow-tooltip>
                    </el-table-column>
                </el-table>
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page="pageNo2"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize2"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize2">
                </el-pagination>

            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    export default {
        name: "goods-onput",
        data() {
            return {
                loading:false,
                activeName: 'first',
                form1:{
                    product_sn:'',
                    product_name:'',
                    role:'',
                    isgift:'',
                     start_time:"",
                    end_time:""
                },
                form2:{
                    product_sn:'',
                    product_name:'',
                    role:'',
                    isgift:'',
                    custType:'',
                    start_time:"",
                    end_time:""
                },
                tableData1: [
                    {},
                    {},
                    {},
                    {},
                    {},
                ],
                tableData2: [
                    {},
                    {},
                    {},
                    {},
                    {},
                ],
                is_active:'0',
                //分页
                pageNo1: 1,//页码
                pageSize1: 20,//每页现实的条数
                totalSize1: 0,//总条数
                //分页
                pageNo2: 1,//页码
                pageSize2: 20,//每页现实的条数
                totalSize2: 0,//总条数
            }
        },
        methods: {
            onSearch(){
                this.loading=true
                if(this.activeName=='first'){
                    this.$get('logistics','/shops.booking.rankings',{
                        per_page:this.pageSize1,
                        page:this.pageNo1,
                        type:this.is_active
                    }).then(res=>{
                        this.tableData1=res.data
                        this.totalSize1=res.meta.total
                this.loading=false
                    })
                }else{
                    
                      this.$get('logistics','/shops.booking.rankings.products',{
                        per_page:this.pageSize2,
                        page:this.pageNo2,
                        type:this.is_active
                    }).then(res=>{
                        this.tableData2=res.data
                        this.totalSize2=res.meta.total
                        this.loading=false
                    })
                }
            },
            //通用商品上架
            generalOnput(){
                this.$router.push({name:'generalOnput'});
            },
            //下架
            del() {
                this.$confirm('下架后此商品会放入下架商品库，且客户无法看到此商品，确定要下架吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
            countFun(temp){
                this.is_active=temp
                this.onSearch()
            },
            handleClick(tab) {
                this.is_active='0'
                this.onSearch()
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.pageNo1 = 1;
                this.onSearch()
                //this.getDealerList();
            },
            handleCurrentChange1(val) {
                this.pageNo1 = val;
                //this.getDealerList();
                this.onSearch()

            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.pageNo2 = 1;
                //this.getGoodsList();
                this.onSearch()

            },
            handleCurrentChange2(val) {
                this.pageNo2 = val;
                //this.getGoodsList();
                //this.getGoodsList();
                this.onSearch()

            },
        },
        created() {
            this.onSearch()
        },
    }
</script>

<style lang="scss" scoped>
/deep/ .countType .active{
    background-color:rgb(230, 243, 242)!important;
    color: rgb(0, 139, 125)!important;
}
</style>